import { Block } from "Content/Block";
import { AboutContainer, AboutText } from "./style";
import jenni from "res/jenni_style_clipped.png";
import { Card, CardContainer } from "Content/style";
import { Image } from "Image";
import { direction } from "Util/direction";

export const About = ({ setImgSrc }) => {
  return (
    <div id="about-me">
      <Block caption={"Über mich"}>
        <AboutContainer>
          <Image
            thumbnailSrc={jenni}
            originalSrc={jenni}
            maxwidth={"300px"}
            setImgSrc={setImgSrc}
            direction={direction.portrait}
          />
          <AboutText>
            <p>Hi, mein Name ist Jenni 😊</p>
            <p>
              Ich bin 1993 geboren und wohne mit meiner kleinen Familie und
              unserem Hund in Dunningen.
            </p>
            <p>
              Schon immer habe ich es geliebt anderen Frisuren zu machen, was
              aber nie über den privaten Raum hinausging.
            </p>
            <p>
              Im Herbst 2020 habe ich endlich den Entschluss gefasst und eine
              Ausbildung zum Hair- und Make-up Artist absolviert. Dort habe ich
              dann auch die Begeisterung für Make-up entdeckt.
            </p>
            <p>
              Nun kann ich meiner Leidenschaft beruflich nachgehen und es
              erfüllt mich jedes Mal mit Freude, wenn ich nach meiner Arbeit ein
              Strahlen im Gesicht meiner Kundinnen sehe und weiß, ich habe alles
              richtig gemacht.
            </p>
          </AboutText>
        </AboutContainer>
        <CardContainer>
          <Card>
            <b>2020</b>
            <p>Ausbildung Hair & Make-up Artist an der Pro Academy Stuttgart</p>
          </Card>
          <Card>
            <b>2021</b>
            <p>
              Hairstyling Workshop bei <nobr>Thanh Thanh</nobr> Hair& Make-up
              Artist
            </p>
          </Card>
          <Card>
            <b>2022</b>
            <p>Hairstyling Onlinekurs HAIRKULES von Alexandra Lederer</p>
          </Card>
          <Card>
            <b>2023</b>
            <p>Masterclass Brautmake-up bei Kristina Gasperas</p>
          </Card>
        </CardContainer>
      </Block>
    </div>
  );
};
